import { publishEvents } from '../Events';
import { version } from '../../package.json';
let ttt;
const setupTracking = (transportLayer) => {
    ttt = transportLayer;
};
const trackEvent = (action, contextData) => {
    ttt === null || ttt === void 0 ? void 0 : ttt.event(action, Object.assign(contextData, { brazeProviderVersion: `${version}` }));
};
const getTrackingLibrary = (transportLayer) => {
    setupTracking(transportLayer);
    const publishBrazeEvent = (event) => {
        transportLayer.publish('stm:braze', event, { fireAndForget: true });
    };
    const trackBrazeInteraction = (placement, eventType, campaignId, additionalPayload) => {
        let eventName;
        if (eventType.includes('.clicked')) {
            eventName = 'brazeClick';
        }
        else if (eventType.includes('.shown')) {
            eventName = 'brazeImpression';
        }
        trackEvent(eventName, {
            brazePlacement: placement,
            brazeTriggerID: campaignId,
            ...additionalPayload,
        });
        publishBrazeEvent({
            type: eventType,
            campaignId,
            ...additionalPayload,
        });
    };
    const trackCardClick = (placement, campaignId) => {
        trackBrazeInteraction(placement, publishEvents.CONTENT_CARD_CLICKED, campaignId);
    };
    const trackCardImpression = (placement, campaignId) => {
        trackBrazeInteraction(placement, publishEvents.CONTENT_CARD_SHOWN, campaignId);
    };
    const trackInAppMessageImpression = (placement, campaignId) => {
        trackBrazeInteraction(placement, publishEvents.IN_APP_MESSAGE_SHOWN, campaignId);
    };
    const trackInAppMessageClick = (placement, campaignId) => {
        trackBrazeInteraction(placement, publishEvents.IN_APP_MESSAGE_CLICKED, campaignId);
    };
    const trackInAppMessageButtonClick = (placement, campaignId) => {
        trackBrazeInteraction(placement, publishEvents.IN_APP_MESSAGE_BUTTON_CLICKED, campaignId);
    };
    const trackInAppMessageHTMLClick = (placement, campaignId, buttonId) => {
        trackBrazeInteraction(placement, publishEvents.IN_APP_MESSAGE_HTML_CLICKED, campaignId, { buttonId });
    };
    const setBrazeCustomAttribute = (userAttribute) => {
        publishBrazeEvent({
            type: publishEvents.SET_CUSTOM_USER_ATTRIBUTE,
            ...userAttribute,
        });
    };
    return {
        trackCardClick,
        trackCardImpression,
        trackInAppMessageImpression,
        trackInAppMessageClick,
        trackInAppMessageButtonClick,
        trackInAppMessageHTMLClick,
        setBrazeCustomAttribute,
    };
};
export { setupTracking, trackEvent, getTrackingLibrary, };
//# sourceMappingURL=tracking.js.map